<template>
    <Loading v-bind:show="showLoading">
        <PageTitle title="Créditos" />
        <div v-if="dadosAba" class="divInfoCredito">
            <Info Titulo=""
                  v-bind:Informacao="dadosAba.saldoTotal.toString()"
                  Descricao="SALDO TOTAL"
                  style="margin-left: -45px !important;"
                  BordaCor="009688"
                  Tipo="moeda" v-if="$featureToggle && $featureToggle.INTEGRA_CREDITOS_SALDOTOTAL" />
            <Info Titulo=""
                  v-bind:Informacao="dadosAba.saldoTotalEmpenhado.toString()"
                  Descricao="SALDO TOTAL EMPENHADO"
                  BordaCor="6361fb"
                  Tipo="moeda" v-if="$featureToggle && $featureToggle.INTEGRA_CREDITOS_SALDOTOTALEMPENHADO" />
        </div>

        <div style="clear:both"></div>

        <div class="md-layout-item md-size-100" v-if="dadosAba">
            <Grid v-bind:Data="dadosAba.creditos"
                  v-bind:Header="header"
                  Name="Creditos"
                  OrderBy="dataCredito"
                  v-bind:HeaderDetalhes="headerDetalhe"
                  v-bind:DetalhesCombo1="dadosAba.tipo"
                  v-bind:DetalhesCombo2="null"
                  v-bind:DetalhesCombo3="null" v-if="$featureToggle && $featureToggle.INTEGRA_CREDITOS_GRID" />
        </div>
    </Loading>
</template>
<script>
    import Grid from '@/components/Grid';
    import Creditos from '@/services/CreditosService.js';
    import Info from '@/components/Info';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import { formatmoeda } from '@/directives/formatmoeda.js';

    export default {
        components: {
            Grid,
            Loading,
            Info,
            PageTitle
        },
        directives: {
            formatmoeda
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.Creditos) {
                        this.dadosAba = a.Creditos;
                    }
                }
                else
                    this.$router.push('home');
            }

            this.creditosService = new Creditos(this);

            if (this.$featureToggle.INTEGRA_CREDITOS_GRID) {
                //Verifica se a aba não está carregada
                if (!this.dadosAba) {
                    //Popula os dados da aba
                    this.showLoading = true;
                    this.creditosService.ListarCreditos({
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAba = data.dados;
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoading = false;
                        });
                }
            }
            else {
                this.$modal.alert(this.$msgFeatureToggle);
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.Creditos = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                aluno: null,
                header: [
                    {
                        Titulo: "Código",
                        Field: "codigo",
                        Width: "40px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Tipo",
                        Field: "tipo",
                        Width: "80px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Descrição",
                        Field: "descricao",
                        Width: "80px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Valor",
                        Field: "valor",
                        Width: "60px",
                        Tipo: "moeda"
                    },
                    {
                        Titulo: "Data",
                        Field: "data",
                        Width: "40px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Competência",
                        Field: "periodo",
                        Width: "40px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Tipo Crédito",
                        Field: "tipo_Credito",
                        Width: "80px",
                        Tipo: "texto"
                    }
                ],
                headerDetalhe: [
                    {
                        Titulo: "Usuário",
                        Field: "usuario",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "S",
                        Field: "sServico",
                        Tipo: "texto"
                    }
                ],
                dadosAba: null,
                showLoading: false,
                expandPrincipal: true,
                expandInfo: true
            }
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }

    .divInfoCredito {
        width: 500px;
        float: left;
        position: relative;
        display: inline;
        padding: 0 0 0 30px;
    }

    .titulo {
        font-size: 15px;
        font-weight: bold;
        padding-left: 15px;
        margin-bottom: 15px;
        margin-left: 0px;
    }
</style>
